import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleButton, TopConsumptionItem } from '../../../../../components';
import { DashboardCardWrapper } from '../../../components/DashboardCardWrapper/dashboard-card-wrapper';
import { useGetEosEstimatedEnergyCostSpacesQuery } from '@client/api';
import { useDashboardFilters } from '../../../context/dashboard-filters.context';
import { NoDataWidgetContent } from '../../../dashboard-basic-view/components/NoDataWidget/no-data-widget';
import { BiDollar } from 'react-icons/bi';
import { toNumberString } from '@client/toolkit';

export function EstimatedEnergyCostSpacesWidget() {
  const { t: tWidget } = useTranslation('widget');
  const { selectedSpaceIds, selectedDateFromIso, selectedDateToIso } = useDashboardFilters();
  const [dataType, setDataType] = useState<'total' | 'm2'>('total');

  const { data, isLoading, isError } = useGetEosEstimatedEnergyCostSpacesQuery(
    {
      type: dataType,
      from: selectedDateFromIso || '',
      to: selectedDateToIso || '',
      spaceIds: selectedSpaceIds,
    },
    {
      skip: !selectedDateFromIso || !selectedDateToIso,
    },
  );

  const spaces = data || [];
  const unit = dataType === 'total' ? 'kr' : 'kr/m²';

  return (
    <DashboardCardWrapper
      to="/reporting/economy-energy-consumption"
      icon={<BiDollar className="text-brand-primary" />}
      title={tWidget('estimatedCostsSpaces.title')}
      titleRightContent={
        <ToggleButton
          condition1="Totalt"
          condition2="Per m²"
          initialCondition={0}
          onChange={(value) => {
            setDataType(value === 0 ? 'total' : 'm2');
          }}
        />
      }
      loading={isLoading}
    >
      {(!isLoading || isError) && spaces.length === 0 ? (
        <NoDataWidgetContent noDataText={tWidget('energy.noData')} />
      ) : (
        <div className="flex flex-col gap-4">
          {spaces?.map((item) => (
            <TopConsumptionItem
              key={item.name}
              name={item.name ?? 'Unknown'}
              value={`${toNumberString(item.value ?? 0, undefined, { maximumFractionDigits: 0 })} ${unit}`}
              percentage={`${item.percentage}`}
            />
          ))}
        </div>
      )}
    </DashboardCardWrapper>
  );
}
